<template>
  <Modal v-model="dialogShow" :canClose="!isFinishing || isFinished" @close="onClose">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div
          class="modal-body d-flex flex-column justify-content-center align-items-center my-3"
          v-if="hasError || isFinishing || isFinished">
          <template v-if="hasError">
            <IconExclamationCircle class="text-danger" size="50" />
            <h3 class="m-0 mt-3">{{ $t('error') }}</h3>
            <h4>{{ hasError }}</h4>
          </template>
          <template v-else-if="isFinished">
            <IconChecks class="text-success" size="50" />
            <h3 class="mt-3">{{ $t('orders.details.finish_campaigns.success') }}</h3>
          </template>
          <template v-else>
            <div class="spinner-border"></div>
            <h3 class="mt-3">{{ $t('orders.details.finish_campaigns') }}</h3>
          </template>
        </div>
        <div v-else class="modal-body">
          <h1 class="mb-3">{{ $t('orders.details.finish_campaigns') }}</h1>
          <p>{{ $t('orders.details.finish_campaigns.description') }}</p>
        </div>
        <div class="modal-footer d-flex" :class="isFinished ? 'justify-content-center' : 'justify-content-between'">
          <button type="button" class="btn" @click="onClose">
            {{ $t('btn.close') }}
          </button>
          <LoadingButton v-if="!isFinished" type="button" class="btn btn-primary" @press="finishCampaigns">
            {{ $t('btn.confirm') }}<i class="ti ti-checks"></i>
          </LoadingButton>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { Modal, LoadingButton } from '@prospective/lithium';
import { ref } from 'vue';
import { IconChecks, IconExclamationCircle } from '@tabler/icons-vue';
import { finishOrderCampaigns } from '@/api/order';

const dialogShow = defineModel({ default: false, type: Boolean });

const emit = defineEmits<{
  (event: 'update:dialogShow', value: boolean): void;
  (event: 'onFinished'): void;
  (event: 'onClose'): void;
}>();
const props = defineProps<{ orderId: string | number }>();

const isFinishing = ref(false);
const isFinished = ref(false);
const hasError = ref('');

function hideDialog() {
  dialogShow.value = false;
}
async function finishCampaigns(stopLoading: () => void) {
  try {
    isFinishing.value = true;
    if (!props.orderId) throw new Error('Something went wrong');

    await finishOrderCampaigns(props.orderId);
    isFinishing.value = false;
    isFinished.value = true;
    emit('onFinished');
  } catch (error: any) {
    hasError.value = error.responseJson?.message ?? error.message ?? 'An error occurred while finishing the campaigns';
  } finally {
    isFinishing.value = false;
    stopLoading?.();
  }
}
function onClose() {
  hideDialog();
  emit('onClose');
}
</script>
